/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { getCountryFromLanguage } from "../../../../core/service/BusinessLogicService"
import { tunnelDataToFinalForm } from "../../../../mappers/tunnelDataMapper"
import BankCoordinatesBloc from "../BankCoordinatesBloc"
import CompanyBloc from "../CompanyBloc"
import MyAddressesBloc from "../MyAddressesBloc"
import SignatoryBloc from "../SignatoryBloc"
import React from "react"
import { Row } from "react-bootstrap"

export default function BplsSummaryBlocOrder({ tunnelData }) {
  const { customer, person } = tunnelData.data
  const configuration = tunnelData.clientPageConfiguration
  const country = getCountryFromLanguage(tunnelData.data.order.orderLanguageTag)

  const getSignatoriesBloc = () => {
    const formValuesData = tunnelDataToFinalForm(
      person,
      customer,
      country,
      tunnelData
    )
    const { signatories } = formValuesData

    return signatories?.map((signatory, index) => {
      return (
        <SignatoryBloc
          key={signatory.name + signatory.firstName}
          tunnelData={tunnelData}
          values={signatory}
          configuration={configuration}
          index={index}
        />
      )
    })
  }
  return (
    <Row>
      <CompanyBloc
        tunnelData={tunnelData}
        values={tunnelDataToFinalForm(person, customer, country, tunnelData)}
        configuration={configuration}
      />
      <BankCoordinatesBloc
        tunnelData={tunnelData}
        values={tunnelDataToFinalForm(person, customer, country, tunnelData)}
        configuration={configuration}
      />
      <MyAddressesBloc
        tunnelData={tunnelData}
        values={tunnelDataToFinalForm(person, customer, country, tunnelData)}
        configuration={configuration}
      />

      {configuration?.signatory &&
        customer?.signatories &&
        getSignatoriesBloc()}
    </Row>
  )
}
